import axios from 'axios';
import CryptoJS from 'crypto-js';

const generateOTP = async (mobileNumber) => {
  try {
    const response = await axios.post('/abcd/api/otp/generate', { mobileNumber });
    return response.data;
  } catch (error) {
    throw error.response?.data || 'OTP generation failed';
  }
};

const validateOTPAndSubmitForm = async (encryptedFormData) => {
  try {
    const response = await axios.post('/abcd/api/otp/validate', {
      encryptedFormData,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || 'OTP validation failed';
  }
};

const generateRedirectUrlWithUUID = async (generatedURL, mob, data, source, channel) => {
  try {
    const response = await axios.post('/abcd/api/otp/redirect', {
      generatedURL,
      mob,
      data,
      source,
      channel,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || 'Redirect URL generation failed';
  }
};

const generateToken = async () => {
  let data = qs.stringify({});
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_TOKEN_URL}`,
    headers: {
      Authorization: `${process.env.REACT_APP_AUTH_TOKEN_HEADERS}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: data,
  };

  try {
    const response = await axios.request(config);
    return response.data.access_token;
  } catch (error) {
    throw error;
  }
};

const getGoldPrice = async () => {
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}` + 'api/sitecore/Widget/MutualFundApi',

      // url: `${process.env.REACT_APP_MF_VRO_URL}` + 'return-calculator',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        currencyPair: 'XAU/INR',
        type: 'BUY',
        endPoint: 'getnonexecutablequote',
      },
    };

    let response = await axios.request(formSubmitConfig);

    let resp = JSON.parse(response?.data);

    return resp;
  } catch (error) {
    throw error;
  }
};

const encryptData = (data, sk, skiv) => {
  const key = CryptoJS.enc.Utf8.parse(sk);
  const ivBytes = CryptoJS.enc.Utf8.parse(skiv);
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv: ivBytes,
    keySize: 256 / 32,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

export {
  generateOTP,
  validateOTPAndSubmitForm,
  generateRedirectUrlWithUUID,
  generateToken,
  getGoldPrice,
  encryptData,
};
